import { useMemo, useState } from 'react';
import type { StudioDataset, StudioField } from 'src/components/star-grid/reportStudio.types';
// A line-set member pick reuses the filter field's data machinery, but lets the operator switch
// hierarchy within the dimension — so it holds its own binding cursor separate from the set's.
export const useStudioLinePicker = (dataset: StudioDataset, initialBindingId: string, members: readonly string[]) => {
  const [bindingId, setBindingId] = useState(initialBindingId);
  const binding = useMemo(() => dataset.bindings.find((item) => item.id === bindingId), [dataset.bindings, bindingId]);
  const field: StudioField = useMemo(
    () => ({ id: 'studio-line-picker', binding_id: bindingId, selection: { kind: 'members', members: [...members] } }),
    [bindingId, members]
  );
  return { bindingId, setBindingId, binding, field };
};
